import { normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "main-container"
};
const _hoisted_2 = {
  class: "fixed-header"
};
import AppMain from './components/AppMain.vue';
import Sidebar from './components/Sidebar/index.vue';
import Navbar from './components/Navbar.vue';
import TagsView from '@/components/Tagsview/index.vue';
import { useStore } from 'vuex';
import { watchSwitchLang } from '@/utils/i18n.js';
export default {
  __name: 'index',
  setup(__props) {
    const store = useStore();
    watchSwitchLang(() => {
      if (store.getters.token) {
        store.dispatch('user/getUserInfo');
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["app-wrapper", [_ctx.$store.getters.sidebarOpened ? 'openSidebar' : 'hideSidebar']])
      }, [_createVNode(Sidebar, {
        id: "guide-sidebar",
        class: "sidebar-container",
        style: _normalizeStyle({
          backgroundColor: _ctx.$store.getters.cssVar.menuBg
        })
      }, null, 8, ["style"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(Navbar), _createVNode(TagsView)]), _createVNode(AppMain)])], 2);
    };
  }
};